import React, { useEffect, useState } from 'react';
import './sidebar.css';
import { Auth } from 'aws-amplify';
import fullLogo from '../SE_Logo_tagline.svg';
import { useNavigate } from "react-router-dom";
import minLogo from '../SE_min_logo.svg';
import { MdComputer } from 'react-icons/md';
import { IoDocuments, IoDocumentAttach, IoSettingsSharp, IoChevronForward } from 'react-icons/io5';
import { FaSitemap, FaBriefcaseMedical, FaTools, FaBell, FaBullhorn, FaWpforms } from 'react-icons/fa';
import { BiError, BiLogOut, BiCctv, BiHelpCircle } from 'react-icons/bi';
import { FiMinimize2 } from 'react-icons/fi';
import { BsArrowsAngleExpand, BsCalendarFill } from 'react-icons/bs';
import { GrDocumentVerified } from 'react-icons/gr';
import { TbCalendarTime, TbCalendarWeek } from 'react-icons/tb';
import { userAppData } from './MainApp.js';
import {
    accessBoolean,
    getProfileImageUrlWithSchoolFallback,
    PROFILE_IMAGE_UPDATED_EVENT
} from './func.js';
import appConfig from '../config';


function iconFinder(icon, desktopView, fullSidebarValue) {
    let size = '24px';
    if (!desktopView) {
        if (fullSidebarValue) {
            size = '24px';
        } else {
            size = '19px';
        }
    }

    switch (icon) {
        case 'IT Support':
            return (
                <MdComputer color='#ffffff' size={size} />
            );
        case 'Reprographics':
            return (
                <IoDocuments color='#ffffff' size={size} />
            );
        case 'SE Inventory':
            return (
                <FaSitemap color='#ffffff' size={size} />
            );
        case 'CCTV Requests':
            return (
                <BiCctv color='#ffffff' size={size} />
            );
        case 'Bookings':
            return (
                <BsCalendarFill color='#ffffff' size={size} />
            );
        case 'Tools':
        case 'Maintenance':
            return (
                <FaTools color='#ffffff' size={size} />
            );
        case 'Medical':
            return (
                <FaBriefcaseMedical color='#ffffff' size={size} />
            );
        case 'Admin Requests':
            return (
                <IoDocumentAttach color='#ffffff' size={size} />
            );
        case 'System Manager':
            return (
                <IoSettingsSharp color='#ffffff' size={size} />
            );
        case 'Forms':
            return (
                <FaWpforms color='#ffffff' size={size} />
            );
        case 'Performance Management':
            return (
                <GrDocumentVerified color='#ffffff' size={size} />
            );
        case 'OnCall':
            return (
                <FaBell color='#ffffff' size={size} />
            );
        case 'Alert':
            return (
                <FaBullhorn color='#ffffff' size={size} />
            );
        default:
            return (
                <BiError color='#ffffff' size={size} />
            );
    }
}

/**
 * Returns the sidebar dropdown icon for bookings group types.
 */
function getBookingsDropdownIcon(groupType) {
    const normalizedGroupType = String(groupType || '').trim().toUpperCase();

    if (normalizedGroupType === 'TIMESLOT') {
        return <TbCalendarTime color='#fbe7bc' size='20px' />;
    }

    if (normalizedGroupType === 'LESSON') {
        return <TbCalendarWeek color='#fbe7bc' size='20px' />;
    }

    return null;
}

/**
 * Returns an inline font-size style for sidebar profile text.
 * The current design size is treated as the maximum, and longer values scale down
 * to help the text remain on a single line without enlarging beyond today's layout.
 */
function getSidebarProfileTextStyle(text, desktopMaxSize, mobileMaxSize, desktopMinSize, mobileMinSize, desktopView) {
    const safeText = String(text || '').trim();
    const characterCount = safeText.length;

    const maxSize = desktopView ? desktopMaxSize : mobileMaxSize;
    const minSize = desktopView ? desktopMinSize : mobileMinSize;

    if (characterCount <= 16) {
        return { fontSize: `${maxSize}px` };
    }

    if (characterCount >= 40) {
        return { fontSize: `${minSize}px` };
    }

    const reductionRatio = (characterCount - 16) / (40 - 16);
    const calculatedSize = maxSize - ((maxSize - minSize) * reductionRatio);

    return { fontSize: `${calculatedSize.toFixed(1)}px` };
}



function SidebarItemWithDropdown(props) {
    let navigate = useNavigate();
    const dropdownEntries = Array.isArray(props.dropdowns) ? props.dropdowns : [];

    function onDropdownItemClick(url) {
        navigate(url);
        if (!props.desktopViewState) { // if mobile view
            let currentState = props.dropdownState;
            props.dropdownStateChange(props.name, currentState);
            props.setFullSidebarState(false);
        }
    }

    function onMainItemClick() {
        let currentState = props.dropdownState;
        props.dropdownStateChange(props.name, currentState);
    }

    const hasDropdownEntries = dropdownEntries.length > 0;

    return (
        <div className="sidebar-item-padding-div">
            <div className='sidebar-item'>
                <div className='sidebar-item-main-item' onClick={() => onMainItemClick()}>
                    <div className='sidebar-item-title-wrap'>
                        {iconFinder(props.name, props.desktopViewState, props.fullSidebarValue)}
                        <span className={props.fullSidebarValue ? 'sidebar-item-text' : 'sidebar-item-text-min'}>{props.name}</span>
                    </div>
                    {props.fullSidebarValue && hasDropdownEntries && (
                        <IoChevronForward className='sidebar-item-chevron' color='#fbe7bc' size='20px' />
                    )}
                </div>

                <div className={props.dropdownState ? 'sidebar-item-dropdown-outer' : 'sidebar-item-dropdown-outer-hide'}>
                    {dropdownEntries.map((dropdownitem) => {
                        return (
                            <div key={dropdownitem["name"]} className='sidebar-item-dropdown-item' onClick={() => (onDropdownItemClick(dropdownitem["url"]))}>
                                {dropdownitem.type && (
                                    <span className='sidebar-dropdown-item-icon'>
                                        {getBookingsDropdownIcon(dropdownitem.type)}
                                    </span>
                                )}
                                <span className={props.fullSidebarValue ? 'sidebar-dropdown-item-text' : 'sidebar-item-text-min'}>{dropdownitem["name"]}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}





function SidebarItemWithoutDropdown(props) {
    let navigate = useNavigate();

    function onItemClick(url) {
        navigate(url)
        props.closeAllDropdowns();
        if (!props.desktopViewState) { // if mobile view
            let currentState = props.dropdownState;
            props.dropdownStateChange(props.name, currentState);
            props.setFullSidebarState(false);
        }
    }

    return (
        <div className="sidebar-item-padding-div" onClick={() => onItemClick(props.url)}>
            <div className='sidebar-item'>
                <div className='sidebar-item-main-item'>
                    <div className='sidebar-item-title-wrap'>
                        {iconFinder(props.name, props.desktopViewState, props.fullSidebarValue)}
                        <span className={props.fullSidebarValue ? 'sidebar-item-text' : 'sidebar-item-text-min'}>{props.name}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default function Sidebar(props) {
    const [itsupportDropdownState, setItsupportDropdownState] = useState(false);
    const [reproDropdownState, setReproDropdownState] = useState(false);
    const [maintenanceDropdownState, setMaintenanceDropdownState] = useState(false);
    const [oncallDropdownState, setOncallDropdownState] = useState(false);
    const [bookingsDropdownState, setBookingsDropdownState] = useState(false);
    const [, setProfileImageRefreshTick] = useState(0);

    // Treat every unexpected module shape as no access so a partial bootstrap
    // payload can still render the modules that loaded successfully.
    const noModuleAccess = { perms: 0 };
    const safeRecord = (value, fallback = noModuleAccess) => (
        value !== null && typeof value === 'object' && !Array.isArray(value)
            ? value
            : fallback
    );
    const itRequestsData = safeRecord(userAppData['itRequestsData']);
    const reproRequestsData = safeRecord(userAppData['reproRequestsData']);
    const bookingsData = safeRecord(userAppData['bookingsData']);
    const bookingsMetadata = safeRecord(userAppData['bookingsMetadata'], { groups: [], rooms: [] });
    const invUserValue = [1, 2, 3, 4].includes(Number(userAppData['invUser'])) ? Number(userAppData['invUser']) : 0;
    const maintenanceUserValue = [1, 2, 3, 4].includes(Number(userAppData['maintenanceUser'])) ? Number(userAppData['maintenanceUser']) : 0;
    const onCallData = safeRecord(userAppData['onCall']);
    const sysManagerData = safeRecord(userAppData['sysManager']);
    const performanceManagementData = safeRecord(userAppData['performanceManagement']);
    const alertData = safeRecord(userAppData['alertData']);
    const toolsData = safeRecord(userAppData['toolsData']);
    const formsData = safeRecord(userAppData['formsData']);


    let navigate = useNavigate();

    const sidebarProfileImageUrl = getProfileImageUrlWithSchoolFallback(
        userAppData['profileImageUrl'],
        userAppData['schoolCode']
    );
    const displayNameText = String(userAppData['displayName'] || '');
    const schoolNameText = String(userAppData['schoolName'] || '');
    const displayNameStyle = getSidebarProfileTextStyle(displayNameText, 20, 20, 13, 13, props.desktopView);
    const schoolNameStyle = getSidebarProfileTextStyle(schoolNameText, 14, 17, 10, 11, props.desktopView);

    useEffect(() => {
        function handleProfileImageUpdated() {
            setProfileImageRefreshTick((currentValue) => currentValue + 1);
        }

        window.addEventListener(PROFILE_IMAGE_UPDATED_EVENT, handleProfileImageUpdated);
        return () => {
            window.removeEventListener(PROFILE_IMAGE_UPDATED_EVENT, handleProfileImageUpdated);
        };
    }, []);

    function returnToDashboard() {
        navigate('/app');
    }

    function toggleSidebarVisibilityStatus() { // toggles between full and minimised sidebar
        // cancel all dropdowns
        setItsupportDropdownState(false);
        setReproDropdownState(false);
        setBookingsDropdownState(false);
        setMaintenanceDropdownState(false);
        setOncallDropdownState(false);

        if (props.fullSidebarValue) {
            props.setFullSidebarState(false);
        } else {
            props.setFullSidebarState(true);
        }
    }

    function closeAllDropdowns() {
        setItsupportDropdownState(false);
        setReproDropdownState(false);
        setMaintenanceDropdownState(false);
        setOncallDropdownState(false);
        setBookingsDropdownState(false);
    }


    function handleDropdownTrigger(name, currentState) {
        props.setFullSidebarState(true);
        setItsupportDropdownState(false);
        setBookingsDropdownState(false);
        setReproDropdownState(false);
        setMaintenanceDropdownState(false);
        setOncallDropdownState(false);
        switch (name) {
            case 'IT Support':
                if (currentState) {
                    setItsupportDropdownState(false);
                } else {
                    setItsupportDropdownState(true);
                }
                break;
            case 'Reprographics':
                if (currentState) {
                    setReproDropdownState(false);
                } else {
                    setReproDropdownState(true);
                }
                break;
            case 'Maintenance':
                if (currentState) {
                    setMaintenanceDropdownState(false);
                } else {
                    setMaintenanceDropdownState(true);
                }
                break;
            case 'OnCall':
                if (currentState) {
                    setOncallDropdownState(false);
                } else {
                    setOncallDropdownState(true);
                }
                break;
            case 'Bookings':
                if (currentState) {
                    setBookingsDropdownState(false);
                } else {
                    setBookingsDropdownState(true);
                }
                break;
            case 'Performance Management':
                // No dropdown required; states already reset above
                break;
            case 'System Manager':
                // No dropdown required; states already reset above
                break;
            default:
                console.log('dropdown switch case code error');
        }
    }

    async function onSignOutClick() {
        await Auth.signOut()
    }

    function onProfileClick() {
        navigate('/app/profile');
    }

    function onAppSupportClick() {
        navigate('/app/support');
    }

    // IT Support Sidebar Code
    const itSupportLink = (itRequestsData?.perms === 1);
    const itLinkDropdowns = [];
    if (itSupportLink) {
        const allowManageRequests = itRequestsData?.allowManageRequests === true;
        if (Number(itRequestsData?.perms ?? 0) === 1 && !allowManageRequests) {
            itLinkDropdowns.push({ "name": "Request Form", "url": "/app/ItSupport/form" });
            itLinkDropdowns.push({ "name": "My IT Requests", "url": "/app/ItSupport/user/requests" });
        } else if (Number(itRequestsData?.perms ?? 0) === 1 && allowManageRequests) {
            itLinkDropdowns.push({ "name": "IT Request Form", "url": "/app/ItSupport/form" });
            itLinkDropdowns.push({ "name": "View Requests", "url": "/app/ItSupport/admin/requests" });
            //itLinkDropdowns.push({ "name": "IT Reports", "url": "/app/ItSupport/reports" });
        } else {
            console.log('error'); // do something more useful here like redirect or update userappdata to 0
        }
    }

    // Reprographics Sidebar Code
    const reproLink = (reproRequestsData?.perms === 1);
    const reproDropdowns = []
    if (reproLink) {
        const allowManageRequests = reproRequestsData?.allowManageRequests === true;
        if (Number(reproRequestsData?.perms ?? 0) === 1 && !allowManageRequests) {
            reproDropdowns.push({ "key": "1", "name": "Request Form", "url": "/app/repro/form" });
            reproDropdowns.push({ "key": "2", "name": "My Requests", "url": "/app/repro/user/requests" });
        } else if (Number(reproRequestsData?.perms ?? 0) === 1 && allowManageRequests) {
            reproDropdowns.push({ "key": "1", "name": "Request Form", "url": "/app/repro/form" });
            reproDropdowns.push({ "key": "2", "name": "View Requests", "url": "/app/repro/admin/requests" });
        } else {
            console.log('error'); // do something more useful here like redirect or update userappdata to 0
        }
    }

    // Bookings Sidebar Code

    const bookingsLink = (bookingsData?.perms === 1);
    const bookingsDropdowns = [];

    if (bookingsLink) {
        const userPerms = bookingsData;
        const allGroupsRaw = Array.isArray(bookingsMetadata?.groups) ? bookingsMetadata.groups : [];
        const timeslotGroups = allGroupsRaw.filter(group => String(group?.type || '').toUpperCase() === 'TIMESLOT');
        const allGroups = allGroupsRaw.filter(group => String(group?.type || 'LESSON').toUpperCase() === 'LESSON');
        const allRooms = Array.isArray(bookingsMetadata?.rooms) ? bookingsMetadata.rooms : [];

        // STEP 1: Build a Set of groupIds the user has access to
        const groupAccessSet = new Set();

        // Direct group access
        if (Array.isArray(userPerms.groupAccess)) {
            userPerms.groupAccess.forEach(entry => {
                const groupId = entry?.id || entry?.groupId;
                if (groupId) {
                    groupAccessSet.add(groupId);
                }
            });
        }

        // Room access → collect groupIds for each room
        if (Array.isArray(userPerms.roomAccess)) {
            const roomIdToGroupId = {};
            allRooms.forEach(room => roomIdToGroupId[room.roomId] = room.groupId);

            userPerms.roomAccess.forEach(entry => {
                const roomId = entry?.id || entry?.roomId;
                const groupId = roomIdToGroupId[roomId];
                if (groupId) {
                    groupAccessSet.add(groupId);
                }
            });
        }

        // Build the BookingTS entry label from metadata, mirroring how other groups are named.
        const bookingTsGroup =
            timeslotGroups.find(group => groupAccessSet.has(group.groupId)) ||
            timeslotGroups[0];
        const fallbackGroup =
            allGroupsRaw.find(group => groupAccessSet.has(group.groupId)) ||
            allGroupsRaw[0];
        const bookingTsLabel = String(bookingTsGroup?.name || fallbackGroup?.name || 'Booking TS');

        bookingsDropdowns.push({
            name: bookingTsLabel,
            url: '/app/bookingsts',
            type: 'TIMESLOT'
        });
        const existingBookingLabels = new Set(bookingsDropdowns.map((item) => String(item.name || '').toLowerCase()));

        // STEP 2: Build dropdowns using group names and IDs
        allGroups.forEach(group => {
            if (groupAccessSet.has(group.groupId)) {
                const groupName = String(group.name || '');
                if (existingBookingLabels.has(groupName.toLowerCase())) {
                    return;
                }
                bookingsDropdowns.push({
                    name: groupName,
                    url: `/app/bookings/${group.groupId}`,
                    type: group.type
                });
                existingBookingLabels.add(groupName.toLowerCase());
            }
        });
    }
   


    // SE Inventory Sidebar Code
    const seinvntLink = accessBoolean(invUserValue);

    // System Manager Sidebar Code
    const sysManagerLink = (sysManagerData?.perms === 1);
    const performanceManagementLink = (performanceManagementData?.perms === 1);
    // Forms follows the shared module convention: perms 1 shows the sidebar item.
    const toolsLink = (toolsData?.perms === 1);
    const formsLink = (formsData?.perms === 1);

    // OnCall Sidebar Code
    const oncallLink = (onCallData?.perms === 1);
    const oncallDropdowns = [];
    if (oncallLink) {
        oncallDropdowns.push({ "name": "New/Active Calls", "url": "/app/oncall" });
        oncallDropdowns.push({ "name": "Archived Requests", "url": "/app/oncall/archive" });
        if (onCallData?.canViewReports === true) {
            oncallDropdowns.push({ "name": "Reports", "url": "/app/oncall/reports" });

        }
    }

    // Alert Sidebar Code
    const alertLink = (alertData?.perms === 1);

    // Maintenance Sidebar Code
    const maintenanceLink = accessBoolean(maintenanceUserValue);
    const maintenanceDropdowns = []
    if (maintenanceLink) {
        if (maintenanceUserValue == 1 || maintenanceUserValue == 2) {
            maintenanceDropdowns.push({ "name": "Request Form", "url": "/app/maintenance/form" });
            maintenanceDropdowns.push({ "name": "My Requests", "url": "/app/maintenance/user/requests" });
        } else if (maintenanceUserValue == 3 || maintenanceUserValue == 4) {
            maintenanceDropdowns.push({ "name": "Request Form", "url": "/app/maintenance/form" });
            maintenanceDropdowns.push({ "name": "View Requests", "url": "/app/maintenance/admin/requests" });
            //maintenanceDropdowns.push({ "name": "Reports", "url": "/app/maintenance/reports" });
        } else {
            console.log('error'); // do something more useful here like redirect or update userappdata to 0
        }
    }











    return (
        <div className={props.fullSidebarValue ? 'sidebar-full' : 'sidebar-minimised'}>
            <div className='sidebar-logo-div' onClick={() => returnToDashboard()}>
                <img className={props.fullSidebarValue ? 'sidebar-logo-full' : 'sidebar-logo-min'} src={props.fullSidebarValue ? fullLogo : minLogo} alt='logo' />
            </div>
            <div
                className={props.fullSidebarValue ? 'sidebar-profile-card' : 'sidebar-profile-card-minimised'}
                onClick={() => onProfileClick()}
            >
                <div className={props.fullSidebarValue ? 'sidebar-displayName-row' : 'sidebar-displayName-minimised'}>
                    {sidebarProfileImageUrl ? (
                        <img src={sidebarProfileImageUrl} alt='Profile' className='sidebar-profile-image' />
                    ) : (
                        <div className='sidebar-profile-placeholder' />
                    )}
                    <div className='sidebar-profile-text-wrap'>
                        <h1
                            className={props.fullSidebarValue ? 'sidebar-displayName' : 'sidebar-displayName-minimised'}
                            style={displayNameStyle}
                        >
                            {displayNameText}
                        </h1>
                        <div className='sidebar-schoolName-actions'>
                            <h1
                                className={props.fullSidebarValue ? 'sidebar-schoolName' : 'sidebar-schoolName-minimised'}
                                style={schoolNameStyle}
                            >
                                {schoolNameText}
                            </h1>
                            {props.fullSidebarValue && (
                                <button
                                    type="button"
                                    className="sidebar-profile-action-button"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onSignOutClick();
                                    }}
                                    aria-label="Sign out"
                                >
                                    <BiLogOut color='#706f6f' size='1em' />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sidebar-main-items">
                {/* IT SUPPORT ITEM */}
                {itSupportLink && <SidebarItemWithDropdown name="IT Support" dropdownState={itsupportDropdownState} dropdownStateChange={handleDropdownTrigger} fullSidebarValue={props.fullSidebarValue} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} dropdowns={itLinkDropdowns} />}

                {/* REPRO ITEM */}
                {reproLink && <SidebarItemWithDropdown name="Reprographics" dropdownState={reproDropdownState} dropdownStateChange={handleDropdownTrigger} fullSidebarValue={props.fullSidebarValue} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} dropdowns={reproDropdowns} />}

                {/* BOOKINGS ITEM */}
                {bookingsLink && <SidebarItemWithDropdown name="Bookings" dropdownState={bookingsDropdownState} dropdownStateChange={handleDropdownTrigger} fullSidebarValue={props.fullSidebarValue} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} dropdowns={bookingsDropdowns} />}

                {/* SE INVENTORY ITEM */}
                {seinvntLink && <SidebarItemWithoutDropdown name="SE Inventory" fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/seinvnt" />}

                {/* MAINTENANCE ITEM */}
                {maintenanceLink && <SidebarItemWithDropdown name="Maintenance" dropdownState={maintenanceDropdownState} dropdownStateChange={handleDropdownTrigger} fullSidebarValue={props.fullSidebarValue} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} dropdowns={maintenanceDropdowns} />}

                {/* ONCALL ITEM */}
                {oncallLink && <SidebarItemWithDropdown name="OnCall" dropdowns={oncallDropdowns} dropdownState={oncallDropdownState} fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/oncall" />}

                {/* ALERT ITEM */}
                {alertLink && <SidebarItemWithoutDropdown name="Alert" fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/alert" />}

                {/* PERFORMANCE MANAGEMENT ITEM */}
                {performanceManagementLink && <SidebarItemWithoutDropdown name="Performance Management" fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/performance-management" />}

                {/* FORMS ITEM */}
                {formsLink && <SidebarItemWithoutDropdown name="Forms" fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/forms" />}

                {/* SE INVENTORY ITEM */}
                {toolsLink && <SidebarItemWithoutDropdown name="Tools" fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/tools" />}
                {sysManagerLink && <SidebarItemWithoutDropdown name="System Manager" fullSidebarValue={props.fullSidebarValue} dropdownStateChange={handleDropdownTrigger} closeAllDropdowns={closeAllDropdowns} setFullSidebarState={props.setFullSidebarState} desktopViewState={props.desktopView} url="/app/sysmanager" />}

            </div>
            <div className='sidebar-minimise-div' onClick={() => toggleSidebarVisibilityStatus()}>
                <div className='sidebar-minimise-icon-wrap'>
                    {props.fullSidebarValue ? <FiMinimize2 color='#ffffff' size='24px' /> : <BsArrowsAngleExpand color='#ffffff' size='24px' />}
                </div>
                <span className={props.fullSidebarValue ? 'sidebar-bottom-item-text' : 'sidebar-item-text-min'}>Minimise Sidebar</span>
            </div>
            <div className='sidebar-version-div'>
                <span className={props.fullSidebarValue ? 'sidebar-bottom-version-text' : 'sidebar-item-text-min'}>App Version: {appConfig['APP_VERSION_NUMBER']}</span>
                {props.fullSidebarValue && (
                    <button
                        type="button"
                        className="sidebar-version-help-button"
                        onClick={(event) => {
                            event.stopPropagation();
                            onAppSupportClick();
                        }}
                        aria-label="App Support"
                    >
                        <BiHelpCircle color='#706f6f' size='1.55em' />
                    </button>
                )}
            </div>


        </div>
    )
}
